import SearchSelect from "@/components/StyledSelect/SearchSelect";
import { useAppSelector } from "@/hooks/hook";
import { GET } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import React, { useEffect, useState } from "react";

interface EventTabsProps {
    currTab: string;
    updateTab?: (tab: string) => void;
    updateBusiness?: (id: string) => void;
}

const EventTabs = ({ currTab, updateTab, updateBusiness }: EventTabsProps) => {
    const tabs = ["Leads", "Bookings", "Completed Events"];
    const user = useAppSelector((store) => store.user);
    const { refreshToken, business_id, first_name, last_name, customerId, card, roles } =
        useAppSelector((store) => store.user);
    const { getActiveCompanyApi } = API_ROUTES;
    const [comapniesData, setComapniesData] = useState<Array<any>>([]);
    const [currentBusiness, setCurrentBusiness] = useState<any>({
        id: business_id,
        name: "Business",
        first_name: "",
        last_name: "",
        customerid: "",
        card_status: false,
        is_standard_package: false
    });

    useEffect(() => {
        (async () => {
            if (user?.email) {
                try {
                    const result = await GET(getActiveCompanyApi, refreshToken);
                    if (result.data) {
                        const currentBus = result.data.find((b: any) => b.id === business_id);
                        setComapniesData(result.data);
                        if (user.roles === 'admin') {
                            setCurrentBusiness(
                                currentBus
                            );
                        }
                        else {
                            setCurrentBusiness((prev: any) => ({
                                ...prev, id: business_id,
                                first_name: first_name,
                                last_name: last_name,
                                customerid: customerId,
                                card_status: card,
                                is_standard_package: currentBus.is_standard_package
                            }));
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        })();
    }, [user])

    useEffect(() => {
        updateBusiness?.(currentBusiness)
    }, [currentBusiness])

    const updateTabfn = (tab: string) => {
        updateTab?.(tab);
    };

    return (
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full min-w-0">
            <div className="w-full sm:w-auto mt-4 sm:mt-0 ml-0 sm:ml-1 shrink-0">
                {roles == "admin" && currTab == 'Leads' && (
                    <SearchSelect
                        height={52}
                        width={180}
                        options={comapniesData}
                        value={{ name: currentBusiness?.name, id: currentBusiness?.id }}
                        onChange={(selectedValue) => {
                            setCurrentBusiness(selectedValue);
                        }}
                        data-testid="search-id"
                        placeholder={"Select Business"}
                        backgroundColor="white"
                    />
                )}
            </div>
            <div className="bg-white p-1 sm:p-2 rounded-lg sm:rounded-full w-full min-w-0 overflow-hidden">
                <ul className="flex justify-center sm:justify-center items-center text-center flex-nowrap overflow-x-auto gap-1 sm:gap-0">
                    {tabs.map((tab) => (
                        <li
                            key={tab}
                            onClick={() => updateTabfn(tab)}
                            className={`rounded-full px-2.5 py-1.5 sm:px-5 sm:py-2.5 text-xs sm:text-sm md:text-base cursor-pointer transition-all duration-200 flex-shrink-0 whitespace-nowrap ${currTab === tab ? "bg-[#282828] text-white shadow-sm" : " text-gray-800 "}`}>
                            {tab}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default EventTabs;
